/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPowerButtonIcon20Regular = forwardRef('TechPowerButtonIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M10.75 2a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0V2Z" }),
        React.createElement("path", { d: "M6.217 4.716a.75.75 0 1 0-.873-1.22 7.999 7.999 0 1 0 9.321.007.75.75 0 0 0-.874 1.218 6.5 6.5 0 1 1-7.574-.005Z" })));
});
